<template>
	<transition name="fade" v-if="config.show">
		<div class="modal-box">
			<div class="modal p-0">
				<div class="modal-header clearfix">
					<h2 class="pull-left">회원 일괄등록</h2>
					<a class="close" @click="$emit('close')">&times;</a>
				</div>
				<div class="modal-body p-15" style="min-height: 1px;">
					<div class="send-box full-width">
						<div class="send-search-box clearfix">
							<div class="search-box pull-left">
								<input id="file" type="file" style="display: none;" ref="fileRef" @change="fileUpload">
								<input id="file-text" class="form-control round full-width m-b-0" type="text" placeholder="파일첨부" v-model="atchFileName" disabled>
							</div>
							<label for="file" class="btn btn-darkgray plus round pull-right f-12" type="button">
								<img class="v-mid" src="images/plus.png" width="15" alt="">
							</label>
						</div>
					</div>
					<dl class="m-t-30 text-left f-14" style="line-height: 1.5;">
						<dt class="text-darkgray text-bold">일괄등록 가이드</dt>
						<dd>-양식을 다운로드 받아 양식폼에 맞게 작성해 주시기 바랍니다</dd>
						<dd>-엑셀파일 외에 다른 파일은 등록되지 않습니다</dd>
						<dd>-직업별 양식을 다르게 가야 하는가?</dd>
						<dd>-보통은 한 기관에서 받음 (생년월일, 성별, 이름, 전화 필요하다고 함)</dd>
					</dl>
					<a class="btn bg-darkgray text-white round m-t-15" href="member_sample.xlsx" target="_blank">양식 다운로드</a>
				</div>
				<div class="modal-footer p-0 m-t-30">
					<button class="btn bg-blue text-white full-width" type="button" @click="registerExcel">&nbsp;&nbsp;확인&nbsp;&nbsp;</button>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import Axios from 'axios'
import server from '../statics/server'

export default {
	name: "ModalUserRegisterExcel",

	default: function() {
		return {
			name: this.name,
			show: false
		}
	},

	data: function() {
		return {
			atchFileId: "",
			atchFileName: ""
		}
	},

	props: {
		config: Object
	},

	methods: {
		fileUpload: async function() {
			const formData = new FormData();
			formData.append("file", this.$refs.fileRef.files[0]);
			try {
				const { data } = await Axios.post(`${server.addr()}${server.api.FILE}`, formData);
				this.atchFileId = data;
				this.atchFileName = this.$refs.fileRef.files[0].name;
			} catch(e) {
				//TODO: error exception
			}
		},
		registerExcel: function() {
			if(this.atchFileId) {
				Axios.put(server.addr()+server.api.MBER_EXCEL, {atchFileId:this.atchFileId}).then(() => {
					this.$emit('close')
				})
			}
		}
	}
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
	transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}
</style>